var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelivered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.991,
    height: 35.991,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-delivered",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_2",
    "data-name": "Exclusion 2",
    d: "M7.5,949h-38a10.445,10.445,0,0,1-7.422-3.079A10.441,10.441,0,0,1-41,938.5v-34a2.482,2.482,0,0,1,.56-1.579l9.79-12a2.511,2.511,0,0,1,1.94-.92H5.7a2.51,2.51,0,0,1,1.94.92l9.79,12A2.5,2.5,0,0,1,18,904.5v34A10.511,10.511,0,0,1,7.5,949Zm-28.964-25.758a2.979,2.979,0,0,0-2.12.878,3,3,0,0,0,0,4.24l10,10a2.979,2.979,0,0,0,2.12.878,2.981,2.981,0,0,0,2.12-.878l10-10a2.987,2.987,0,0,0-.074-4.166,2.979,2.979,0,0,0-2.122-.879,2.989,2.989,0,0,0-2.045.805l-4.88,4.86V914a3,3,0,0,0-3-3,3,3,0,0,0-3,3v15l-4.88-4.88A2.982,2.982,0,0,0-21.464,923.242ZM-27.52,895h0l-5.72,7H10.2l-5.72-7Z",
    transform: "translate(41 -890)",
    fill: "#fafafa"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelivered);
export default __webpack_public_path__ + "static/media/icon-delivered.695020ea356982559bd9e4104f535f5f.svg";
export { ForwardRef as ReactComponent };